import { useSalesDocumentOverview } from '@/features/sales/salesApi';
import { RevenueChart } from '../RevenueChart';

/** Umsatzverlauf (fakturiert). Finanz-Widget — nur mit dashboard.viewfinancials (Registry). */
export function RevenueWidget() {
  const salesDocs = useSalesDocumentOverview();
  return <RevenueChart docs={salesDocs.data?.data ?? []} isLoading={salesDocs.isLoading} />;
}
